/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as KitRouteImport } from "./routes/[_]kit"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as AuthenticatedIndexRouteImport } from "./routes/_authenticated/index"
import { Route as AuthenticatedCatalogueRouteImport } from "./routes/_authenticated/catalogue"
import { Route as AuthenticatedDispenseRouteImport } from "./routes/_authenticated/dispense"
import { Route as AuthenticatedInventoryRouteImport } from "./routes/_authenticated/inventory"
import { Route as AuthenticatedPatientsRouteImport } from "./routes/_authenticated/patients"
import { Route as AuthenticatedPosRouteImport } from "./routes/_authenticated/pos"
import { Route as AuthenticatedReportsRouteImport } from "./routes/_authenticated/reports"
import { Route as AuthenticatedSettingsRouteImport } from "./routes/_authenticated/settings"

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const KitRoute = KitRouteImport.update({
  id: "/_kit",
  path: "/_kit",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCatalogueRoute = AuthenticatedCatalogueRouteImport.update({
  id: "/catalogue",
  path: "/catalogue",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDispenseRoute = AuthenticatedDispenseRouteImport.update({
  id: "/dispense",
  path: "/dispense",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInventoryRoute = AuthenticatedInventoryRouteImport.update({
  id: "/inventory",
  path: "/inventory",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPatientsRoute = AuthenticatedPatientsRouteImport.update({
  id: "/patients",
  path: "/patients",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPosRoute = AuthenticatedPosRouteImport.update({
  id: "/pos",
  path: "/pos",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: "/reports",
  path: "/reports",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AuthenticatedRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthenticatedIndexRoute
  "/_kit": typeof KitRoute
  "/login": typeof LoginRoute
  "/catalogue": typeof AuthenticatedCatalogueRoute
  "/dispense": typeof AuthenticatedDispenseRoute
  "/inventory": typeof AuthenticatedInventoryRoute
  "/patients": typeof AuthenticatedPatientsRoute
  "/pos": typeof AuthenticatedPosRoute
  "/reports": typeof AuthenticatedReportsRoute
  "/settings": typeof AuthenticatedSettingsRoute
}
export interface FileRoutesByTo {
  "/_kit": typeof KitRoute
  "/login": typeof LoginRoute
  "/catalogue": typeof AuthenticatedCatalogueRoute
  "/dispense": typeof AuthenticatedDispenseRoute
  "/inventory": typeof AuthenticatedInventoryRoute
  "/patients": typeof AuthenticatedPatientsRoute
  "/pos": typeof AuthenticatedPosRoute
  "/reports": typeof AuthenticatedReportsRoute
  "/settings": typeof AuthenticatedSettingsRoute
  "/": typeof AuthenticatedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/_kit": typeof KitRoute
  "/login": typeof LoginRoute
  "/_authenticated/catalogue": typeof AuthenticatedCatalogueRoute
  "/_authenticated/dispense": typeof AuthenticatedDispenseRoute
  "/_authenticated/inventory": typeof AuthenticatedInventoryRoute
  "/_authenticated/patients": typeof AuthenticatedPatientsRoute
  "/_authenticated/pos": typeof AuthenticatedPosRoute
  "/_authenticated/reports": typeof AuthenticatedReportsRoute
  "/_authenticated/settings": typeof AuthenticatedSettingsRoute
  "/_authenticated/": typeof AuthenticatedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/_kit"
    | "/login"
    | "/catalogue"
    | "/dispense"
    | "/inventory"
    | "/patients"
    | "/pos"
    | "/reports"
    | "/settings"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/_kit"
    | "/login"
    | "/catalogue"
    | "/dispense"
    | "/inventory"
    | "/patients"
    | "/pos"
    | "/reports"
    | "/settings"
    | "/"
  id:
    | "__root__"
    | "/_authenticated"
    | "/_kit"
    | "/login"
    | "/_authenticated/catalogue"
    | "/_authenticated/dispense"
    | "/_authenticated/inventory"
    | "/_authenticated/patients"
    | "/_authenticated/pos"
    | "/_authenticated/reports"
    | "/_authenticated/settings"
    | "/_authenticated/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  KitRoute: typeof KitRoute
  LoginRoute: typeof LoginRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_kit": {
      id: "/_kit"
      path: "/_kit"
      fullPath: "/_kit"
      preLoaderRoute: typeof KitRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/": {
      id: "/_authenticated/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/catalogue": {
      id: "/_authenticated/catalogue"
      path: "/catalogue"
      fullPath: "/catalogue"
      preLoaderRoute: typeof AuthenticatedCatalogueRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/dispense": {
      id: "/_authenticated/dispense"
      path: "/dispense"
      fullPath: "/dispense"
      preLoaderRoute: typeof AuthenticatedDispenseRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/inventory": {
      id: "/_authenticated/inventory"
      path: "/inventory"
      fullPath: "/inventory"
      preLoaderRoute: typeof AuthenticatedInventoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/patients": {
      id: "/_authenticated/patients"
      path: "/patients"
      fullPath: "/patients"
      preLoaderRoute: typeof AuthenticatedPatientsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/pos": {
      id: "/_authenticated/pos"
      path: "/pos"
      fullPath: "/pos"
      preLoaderRoute: typeof AuthenticatedPosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/reports": {
      id: "/_authenticated/reports"
      path: "/reports"
      fullPath: "/reports"
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/settings": {
      id: "/_authenticated/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedCatalogueRoute: typeof AuthenticatedCatalogueRoute
  AuthenticatedDispenseRoute: typeof AuthenticatedDispenseRoute
  AuthenticatedInventoryRoute: typeof AuthenticatedInventoryRoute
  AuthenticatedPatientsRoute: typeof AuthenticatedPatientsRoute
  AuthenticatedPosRoute: typeof AuthenticatedPosRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCatalogueRoute: AuthenticatedCatalogueRoute,
  AuthenticatedDispenseRoute: AuthenticatedDispenseRoute,
  AuthenticatedInventoryRoute: AuthenticatedInventoryRoute,
  AuthenticatedPatientsRoute: AuthenticatedPatientsRoute,
  AuthenticatedPosRoute: AuthenticatedPosRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  KitRoute: KitRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
